import { useState, useEffect } from 'react'

export const useWindowSize = () => {
  const INNER_WIDTH = 260 // WIDTH of inner Nav bar
  const OUTER_WIDTH = 100 // Width of outer Nav bar
  const PADDING_WIDTH = 44
  const HEADER_HEIGHT = 66.76
  const FOOTER_HEIGHT = 60
  const PADDING_HEIGHT = 32
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    view_width:
      window.innerWidth - INNER_WIDTH - OUTER_WIDTH - 2 * PADDING_WIDTH,
    view_height:
      window.innerHeight - HEADER_HEIGHT - FOOTER_HEIGHT - 2 * PADDING_HEIGHT,
  })

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        view_width:
          window.innerWidth - INNER_WIDTH - OUTER_WIDTH - 2 * PADDING_WIDTH,
        view_height:
          window.innerHeight -
          HEADER_HEIGHT -
          FOOTER_HEIGHT -
          2 * PADDING_HEIGHT,
      })
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowSize
}
